/**
 * Unit conversions.
 *
 * The simulation is SI everywhere (metres, seconds, kilograms, radians, pascals, kelvin).
 * Aviation units exist *only* at the UI boundary — convert on the way out, never store.
 */

/** Metres per foot. */
export const M_PER_FT = 0.3048;
/** Feet per metre. */
export const FT_PER_M = 1 / M_PER_FT;
/** Metres per second per knot. */
export const MPS_PER_KT = 0.514444;
/** Knots per metre per second. */
export const KT_PER_MPS = 1 / MPS_PER_KT;
/** Metres per nautical mile. */
export const M_PER_NM = 1852;
/** Pascals per inch of mercury. */
export const PA_PER_INHG = 3386.389;
/** Kilograms per pound. */
export const KG_PER_LB = 0.45359237;
/** Watts per horsepower (mechanical). */
export const W_PER_HP = 745.699872;
/** Newtons per pound-force. */
export const N_PER_LBF = 4.4482216152605;

export const metresToFeet = (m: number): number => m * FT_PER_M;
export const feetToMetres = (ft: number): number => ft * M_PER_FT;
export const mpsToKnots = (mps: number): number => mps * KT_PER_MPS;
export const knotsToMps = (kt: number): number => kt * MPS_PER_KT;
/** Vertical speed [m/s] to feet per minute. */
export const mpsToFpm = (mps: number): number => mps * FT_PER_M * 60;
export const fpmToMps = (fpm: number): number => (fpm / 60) * M_PER_FT;
export const pascalsToInHg = (pa: number): number => pa / PA_PER_INHG;
export const inHgToPascals = (inhg: number): number => inhg * PA_PER_INHG;
export const kgToPounds = (kg: number): number => kg / KG_PER_LB;
export const poundsToKg = (lb: number): number => lb * KG_PER_LB;
export const hpToWatts = (hp: number): number => hp * W_PER_HP;
export const wattsToHp = (w: number): number => w / W_PER_HP;
export const lbfToNewtons = (lbf: number): number => lbf * N_PER_LBF;
export const newtonsToLbf = (n: number): number => n / N_PER_LBF;
export const celsiusToKelvin = (c: number): number => c + 273.15;
export const kelvinToCelsius = (k: number): number => k - 273.15;
